module.exports = __webpack_public_path__ + "static/media/5-8.ad06845d.png";